export const hasSubscribedToNewsletter = user => user && user.activeMailingOffer;



// WEBPACK FOOTER //
// ./src/services/account/utils.js